import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import { BooleanInput, Edit, FormTab, TabbedForm, TextInput, type EditProps } from "react-admin";

import { AssignmentsTabCountProvider, useAssignmentsTabTotal } from "./AssignmentsTabCountContext";
import AssignmentsTab from "./tabs/AssignmentsTab";

function AssignedThalisTabLabel() {
  const total = useAssignmentsTabTotal();
  return (
    <Badge badgeContent={total} color="primary" max={999999} showZero>
      <Box component="span" sx={{ pr: 2, display: "inline-block" }}>
        Assigned thalis
      </Box>
    </Badge>
  );
}

export default function FmbThaliDistributorEdit(props: EditProps) {
  return (
    <Edit {...props} title="Edit thali distributor">
      <AssignmentsTabCountProvider>
        <TabbedForm>
          <FormTab label="Basic">
            <TextInput source="name" fullWidth isRequired />
            <TextInput
              source="phone"
              fullWidth
              helperText="E.164 phone (e.g. +919876543210). Required when portal access is enabled."
            />
            <BooleanInput
              source="portalEnabled"
              label="Portal access"
              helperText="Allow this distributor to sign in with phone OTP at /fmb-thali-distributor/login"
            />
            <BooleanInput source="isActive" />
            <TextInput source="remarks" fullWidth multiline />
          </FormTab>
          <FormTab label={<AssignedThalisTabLabel />}>
            <AssignmentsTab />
          </FormTab>
        </TabbedForm>
      </AssignmentsTabCountProvider>
    </Edit>
  );
}
